import { Controller } from "@hotwired/stimulus"

// QuotaTerritoriale di components/QuotaTerritoriale.js: attivarla riparte dai valori vuoti (percentuale, «La quota non
// rimborsabile», nessuna regione, comune, unità locale o fonte); toglierla nasconde i campi e li tiene. Con «La quota
// da restituire» mostra il complemento (100 − percentuale). I comuni scelti nel ComunePicker diventano pulsanti
// «Comune (SIGLA) · Rimuovi» con i loro campi; regioni e unità locale scelte sono campi nascosti nell'ordine dei clic; le fonti (righe_controller) sono al più 10.
export default class extends Controller {
  static targets = ["attiva", "dettaglio", "percentuale", "fonte", "complemento", "nonRimborsabile", "daRestituire",
    "casella", "elenco", "comuni", "modelloComune", "fonti", "aggiungi"]

  attiva() {
    const on = this.attivaTarget.checked
    if (on) {
      this.percentualeTarget.value = ""
      this.fonteTarget.value = "non_rimborsabile"
      this.casellaTargets.forEach((c) => { c.checked = false })
      this.elencoTargets.forEach((e) => e.querySelectorAll("[data-valore]").forEach((x) => x.remove()))
      this.comuniTarget.querySelectorAll("[data-comune], [data-comune-senza-dettaglio]").forEach((x) => x.remove())
      this.fontiTarget.innerHTML = ""
    }
    this.dettaglioTargets.forEach((el) => { el.hidden = !on })
    this.aggiorna()
    this.conta()
  }

  // toggle di React: una casella scelta va in fondo all'elenco (campo nascosto), tolta esce; l'ordine è quello salvato
  // e poi dei clic, come lo mandava l'originale
  scegli(event) {
    const casella = event.target
    const elenco = this.elencoTargets.find((e) => e.dataset.elenco === casella.dataset.elenco)
    const campo = [...elenco.querySelectorAll("[data-valore]")].find((x) => x.dataset.valore === casella.value)
    if (!casella.checked) { campo?.remove(); return }
    if (campo) return
    const nuovo = elenco.querySelector("input").cloneNode()
    nuovo.value = casella.value
    nuovo.dataset.valore = casella.value
    elenco.append(nuovo)
  }

  aggiorna() {
    const pct = this.percentualeTarget.value
    this.complementoTarget.hidden = !(this.attivaTarget.checked && this.fonteTarget.value === "da_restituire")
    this.nonRimborsabileTarget.textContent = pct || "…"
    this.daRestituireTarget.textContent = pct !== "" ? String(Number((100 - Number(pct)).toFixed(6))) : "…"
  }

  aggiungiComune(event) {
    const c = event.detail?.comune
    if (!c || this.comuniTarget.querySelector(`[name$="[comuni][]"][value="${CSS.escape(c.code)}"]`)) return
    const voce = this.modelloComuneTarget.content.firstElementChild.cloneNode(true)
    voce.dataset.comune = c.code
    voce.querySelector("button").textContent = `${c.comune} (${c.sigla}) · Rimuovi`
    const [codice, dettaglio] = voce.querySelectorAll("input")
    codice.value = c.code
    dettaglio.value = JSON.stringify(c)
    this.comuniTarget.append(voce)
    this.cambiato()
  }

  togliComune(event) {
    event.currentTarget.closest("[data-comune]").remove()
    this.cambiato()
  }

  // per conserva_modifiche e il campo `_presente`: la quota è cambiata anche senza un input
  cambiato() {
    this.element.dispatchEvent(new Event("change", { bubbles: true }))
  }

  conta() {
    this.aggiungiTarget.hidden = !this.attivaTarget.checked || this.fontiTarget.querySelectorAll("[data-righe-target='riga']").length >= 10
  }
}
